module.exports = __webpack_public_path__ + "static/img/workout.7532d0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/kfit/workout.png
// module id = Qqwv
// module chunks = 1